// extracted by mini-css-extract-plugin
export default {"screen":"screen__7306aa54","all-center":"all-center__640ea7e0","title":"title__0258ffa2","marginBottomS20":"marginBottomS20__d49005e1","fontSize32":"fontSize32__7ef2f14e"};